import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css"; // Import the CSS file

const Home: React.FC = () => {
  const navigate = useNavigate();
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789@#$%^&*()*&^%".split("");
  const targetText = "SOLVE THE $RIDDLE";

  const handleButtonClick = () => {
    navigate("/riddle");
  };

  useEffect(() => {
    // Set the initial glow color to neon white
    document.documentElement.style.setProperty('--glow-color', 'hsl(0, 0%, 100%)');

    const updateGlowColor = (e: MouseEvent | TouchEvent) => {
      let x: number = 0, y: number = 0;

      if (e.type === "mousemove") {
        const mouseEvent = e as MouseEvent;
        x = mouseEvent.clientX;
        y = mouseEvent.clientY;
      } else if (e.type === "touchmove") {
        const touchEvent = e as TouchEvent;
        if (touchEvent.touches.length > 0) {
          x = touchEvent.touches[0].clientX;
          y = touchEvent.touches[0].clientY;
        }
      }

      const width = window.innerWidth;
      const height = window.innerHeight;

      const xPercent = x / width;
      const yPercent = y / height;

      const hue = xPercent * 120; // Green hue range
      const lightness = 50 + yPercent * 10; // Lightness range from 50% to 60%

      document.documentElement.style.setProperty('--glow-color', `hsl(${hue}, 100%, ${lightness}%)`);
    };

    window.addEventListener("mousemove", updateGlowColor);
    window.addEventListener("touchmove", updateGlowColor);

    return () => {
      window.removeEventListener("mousemove", updateGlowColor);
      window.removeEventListener("touchmove", updateGlowColor);
    };
  }, []);

  useEffect(() => {
    const canvas = document.getElementById("matrix") as HTMLCanvasElement;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const fontSize = 16;
    const columns = canvas.width / fontSize;
    const drops = Array.from({ length: columns }, () => Math.floor(Math.random() * canvas.height / fontSize));

    const speedFactor = 1; // Adjust this value to control the speed
    const startDelay = 500; // 1 second delay before the animation starts

    // Create an array to store the delay for each column
    const columnDelays = Array.from({ length: columns }, () => Math.random() * 2000); // Random delay up to 2 seconds

    const draw = () => {
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#0F0";
      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i++) {
        // Check if the delay for this column has passed
        if (columnDelays[i] > 0) {
          columnDelays[i] -= 33; // Decrease the delay by the interval time
          continue;
        }

        if (Math.random() > 0.9) continue; // Reduce the number of falling numbers

        const text = letters[Math.floor(Math.random() * letters.length)];
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.9) {
          drops[i] = 0;
        }

        drops[i] += speedFactor;
      }
    };

    let interval: NodeJS.Timeout;

    setTimeout(() => {
      interval = setInterval(draw, 33);
      setTimeout(() => {
        document.getElementById("scrambled-text")!.style.display = "block";
        scrambleText();
      }, 1000); // Show content after 1 second
    }, startDelay);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  const scrambleText = () => {
    let currentText = targetText.split("").map(() => " ");
    let index = 0;
    let attemptCounter = 0;
  
    const scrambleInterval = setInterval(() => {
      if (index >= targetText.length) {
        clearInterval(scrambleInterval);
        document.getElementById("enter-button")!.style.display = "block";
        return;
      }
  
      if (attemptCounter >= 10) {
        currentText[index] = targetText[index];
        document.getElementById("scrambled-text")!.innerText = currentText.join("");
        index++;
        attemptCounter = 0; // Reset the counter for the next letter
      } else {
        currentText[index] = letters[Math.floor(Math.random() * letters.length)];
        document.getElementById("scrambled-text")!.innerText = currentText.join("");
  
        if (Math.random() > 0.9) {
          currentText[index] = targetText[index];
          document.getElementById("scrambled-text")!.innerText = currentText.join("");
          index++;
          attemptCounter = 0; // Reset the counter for the next letter
        } else {
          attemptCounter++;
        }
      }
    }, 50);
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        flexDirection: "column",
      }}
    >
      <canvas
        id="matrix"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      ></canvas>
      <div id="scrambled-text" style={{ display: "none", fontFamily: "Times New Roman", fontSize: "4rem", fontWeight: "bold", color: "white", textShadow: `0 0 10px var(--glow-color), 0 0 20px var(--glow-color), 0 0 30px var(--glow-color)`, zIndex: 1 }}></div>
      <button
        id="enter-button"
        onClick={handleButtonClick}
        style={{
          display: "none",
          marginTop: "40px", // Increased margin to add more padding
          padding: "15px 30px", // Increased padding to make the button bigger
          fontFamily: "Times New Roman",
          fontSize: "2rem", // Increased font size
          fontWeight: "bold",
          color: "white",
          backgroundColor: "black", // Updated background color
          border: `2px solid var(--glow-color)`,
          borderRadius: "25px",
          textShadow: `0 0 10px var(--glow-color), 0 0 20px var(--glow-color), 0 0 30px var(--glow-color)`,
          zIndex: 1,
          cursor: "pointer",
        }}
      >
        Enter
      </button>
    </div>
  );
};

export default Home;